import { AxiosPromise } from 'axios';
import { HuohuaRequestHelper } from '@/service/helper/HuohuaRequestHelper';
import { ServiceOption } from '@/service/helper/ServiceOption';
import PostOption = ServiceOption.PostOption;
import GetOption = ServiceOption.GetOption;
import DeleteOption = ServiceOption.DeleteOption;
import PutOption = ServiceOption.PutOption;

export class BaseServiceImpl {
  public static jsonContentType = 'application/json; charset=UTF-8';

  public static getPostOption() {
    return new PostOption();
  }

  public static getGetOption() {
    return new GetOption();
  }

  public static getDeleteOption() {
    return new DeleteOption();
  }

  public static getPutOption() {
    return new PutOption();
  }

  public static clear(serviceImp: BaseServiceImpl) {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    serviceImp = null;
  }

  protected huohuaRequest(option: any): AxiosPromise {
    return HuohuaRequestHelper.getInstance().getHuohuaRequest(option);
  }
}
